// Pure helpers + shared types for SHARE items. Kept separate from the
// component file so Vite's Fast Refresh isn't disabled by mixed exports.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ShareItemLike = any;

export const itemTypeLabel = (t: string | null | undefined): string => {
  if (t === "PROJECT") return "Projekt";
  if (t === "POST") return "Post";
  return t ?? "";
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const creatorName = (c: any): string => {
  if (!c) return "";
  const parts = [c.name?.given, c.name?.family].filter(Boolean) as string[];
  if (parts.length) return parts.join(" ");
  return c.formattedName ?? "";
};

export const fmtCount = (n: number | null | undefined): string => {
  const v = Number(n ?? 0);
  return v >= 1000 ? (v / 1000).toFixed(1).replace(/\.0$/, "") + "k" : String(v);
};

export const fiveStarRounded = (n: number | null | undefined): string =>
  (Math.round((Number(n) || 0) * 2) / 2).toFixed(1);
